import { create } from 'zustand';
import AsyncStorage from '@react-native-async-storage/async-storage';

export interface ListInfo {
  uri: string;
  cid: string;
  name: string;
  description?: string;
  avatar?: string;
  purpose: 'app.bsky.graph.defs#curatelist' | 'app.bsky.graph.defs#modlist';
  createdAt: string;
}

interface ListStore {
  lists: ListInfo[];
  isLoading: boolean;
  error: string | null;
  
  setLists: (lists: ListInfo[]) => void;
  addList: (list: ListInfo) => void;
  removeList: (uri: string) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  
  // 永続化
  loadLists: () => Promise<void>;
  saveLists: () => Promise<void>;
}

const STORAGE_KEY = '@pixelsky/lists';

export const useListStore = create<ListStore>((set, get) => ({
  lists: [],
  isLoading: false,
  error: null,
  
  setLists: (lists) => {
    set({ lists });
    get().saveLists();
  },
  
  addList: (list) => {
    set((state) => ({
      lists: [...state.lists, list],
    }));
    get().saveLists();
  },
  
  removeList: (uri) => {
    set((state) => ({
      lists: state.lists.filter((l) => l.uri !== uri),
    }));
    get().saveLists();
  },
  
  setLoading: (loading) => set({ isLoading: loading }),
  
  setError: (error) => set({ error }),
  
  loadLists: async () => {
    try {
      const stored = await AsyncStorage.getItem(STORAGE_KEY);
      if (stored) {
        const lists = JSON.parse(stored);
        set({ lists });
      }
    } catch (error) {
      console.error('Load lists error:', error);
    }
  },
  
  saveLists: async () => {
    try {
      const { lists } = get();
      await AsyncStorage.setItem(STORAGE_KEY, JSON.stringify(lists));
    } catch (error) {
      console.error('Save lists error:', error);
    }
  },
}));
